import type { MarketIdentifiers } from '$lib/types/market';
import { SYNTHETIX_PERP_CONNECTOR } from './constants';

export async function getSynthetixConnector(marketIdentifier: MarketIdentifiers = 'sBNBPERP') {
	return SYNTHETIX_PERP_CONNECTOR;
}
